module.exports = __webpack_public_path__ + "img/foods.c3862b4b.webp";